/**
 * grid.tsx
 */
import Animator from '@components/elements/animator/animator';
import Focus from '@shared/types/enums/focus';
import GridArrowUp from './gridArrowUp';
import MosaicContext from '@shared/components/utils/context/mosaicContext';
import useCard from '../lib/useCard';
import { ContextType } from '@shared/types/enums/context';
import { selectFocus } from '@shared/store/slices/focus.slice';
import { selectMagicRemoteEnabled } from '@shared/store/slices/magicRemote.slice';
import { selectMenuCollapse } from '@shared/store/slices/menu.slice';
import { useContext } from 'react';
import { useAppSelector } from '@shared/store/hooks';

/**
 * Grid component. This component is tightly coupled to mosaic.
 * It is used to display the grid of items in the mosaic.
 */
export default function Grid() {
  // Context
  const { config, data, index, onMouseEnter, selectAsset } =
    useContext(MosaicContext);

  // Selectors
  const focus = useAppSelector(selectFocus);
  const enabled = useAppSelector(selectMagicRemoteEnabled);
  const menuExpanded = !useAppSelector(selectMenuCollapse);

  // Card
  const { Card } = useCard(config?.displayMode);
  // Render
  return (
    <Animator
      id={'mosaicContainer'}
      collapse={{
        horizontal: menuExpanded,
        vertical: config?.description,
      }}
      onMouseEnter={onMouseEnter}
      type={Animator.Type.GRID}
    >
      <GridArrowUp />
      {data?.map((item, idx) => {
        const hide = idx < config?.minimumIndex;
        return (
          <Card
            focused={!enabled && focus === Focus.MOSAIC && index === idx}
            hide={hide}
            item={item}
            key={idx}
            context={ContextType.MOSAIC}
            onClick={() => selectAsset(idx)}
          />
        );
      })}
    </Animator>
  );
}
